module.exports = global["$"] = require("-!/var/lib/jenkins/workspace/001_Deployments/Portal/tdg-prd-ppo-app-001/webapp/node_modules/expose-loader/index.js?jQuery!/var/lib/jenkins/workspace/001_Deployments/Portal/tdg-prd-ppo-app-001/webapp/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/001_Deployments/Portal/tdg-prd-ppo-app-001/webapp/~/jquery/dist/jquery.js
// module id = 1
// module chunks = 0